import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table, Label, Alert } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'
import ActivityActions from './ActivityActions'

export default function CalendarActivityReportForm() {
  console.log('CalendarActivityReportForm rendered')

  let initialInputs = {
    dateFrom: '',
    dateTo: '',
    actionType: null
  }

  const navigate = useNavigate()
  initialInputs = initialFormValues('CalendarActivityReportForm', navigate, initialInputs)
  const { inputs, handleInputChange, handleSubmit } = useForm(initialInputs, submitSearch, enterKeyHandler(submitSearch))
  const [errors, setErrors] = useState('')

  async function submitSearch() {
    console.log('CalendarActivityReportForm.submitSearch', inputs)
    inputs.validationMessage = ''
    if (!inputs.dateFrom && !inputs.dateTo) {
      inputs.validationMessage = 'A \'from\' and/or \'to\' date must be specified'
    }
    if (inputs.validationMessage) {
      setErrors(inputs.validationMessage)
      return
    }
    inputs.orderBy = '1'
    inputs.orderDir = 'ASC'
    submitFormValues('CalendarActivityReportForm', navigate, inputs, 'reports.activity')
  }
  let formFeedback = ''
  if (errors) {
    formFeedback = <tr><td colSpan={2}><Alert className='custom-alert' color='danger' style={{width: '100%', textAlign: 'center', marginBottom:'0px'}}>{inputs.validationMessage}</Alert></td></tr>
  }
  console.log(formFeedback)
  return (
    <div className="custom-scroll">
        
      <form className="form" onSubmit={handleSubmit}>
        <div>
          <Table bordered className="custom-table custom-form-table">
            <FormHeading headingText='Activity Report' />
            <tbody>
              {formFeedback}
              <DateRangeInput label='Date Modified' name='date' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateFrom} defaultValueTo={inputs.dateTo} />
              <tr>
                <td><Label><b>Action Type</b></Label></td>
                <td><ActivityActions handleChange={handleInputChange} defaultValue={inputs.actionType} /></td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}